import { CheckboxProps } from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"

import { CheckboxIcon, CheckboxCheckedIcon, CheckboxIndeterminateIcon } from "@l2r-front/l2r-icons"

import * as Styled from "./L2RCheckbox.styled"

type L2RCheckboxProps = {
    className?: string
    color?: "primary" | "default"
    label?: string
    labelPosition?: "top" | "start" | "bottom" | "end"
    value: boolean
} & Omit<CheckboxProps, "color">

export const L2RCheckbox = (props: L2RCheckboxProps) => {

    const {
        className,
        color = "primary",
        label,
        labelPosition = "start",
        value,
        ...checkboxProps
    } = props

    return <FormControlLabel
        className={className}
        onClick={(event) => event.stopPropagation()}
        control={<Styled.Checkbox
            {...checkboxProps}
            icon={<CheckboxIcon />}
            checkedIcon={<CheckboxCheckedIcon />}
            indeterminateIcon={<CheckboxIndeterminateIcon />}
            checked={value}
            checkboxColor={color}
        />}
        label={label}
        labelPlacement={labelPosition}
    />
}
